import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { FooterSectionHeading, FooterSectionWrapper } from "./FooterSectionWrapper";
import { FooterList, FooterListEl } from "./FooterList";
import Link from "next/link";
import { signIn } from "next-auth/react";
import { Divider, FacebookOutlineIcon, InstagramOutlineIcon, SimpleImage, TiktokOutlineIcon, TwitterOutlineIcon, Typography } from "@parkschannel/ui";
import { useAnalytics } from "../../../../utils";
export const Footer = ()=>{
    const { onButtonClick  } = useAnalytics();
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-neutral-100 py-12 px-4 w-full ",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "w-full max-w-7xl mx-auto",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "w-full flex flex-col gap-y-10 md:gap-y-12 lg:flex-row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "w-[344px] h-[52px] relative w-full lg:w-[427px]",
                            children: /*#__PURE__*/ _jsx(Link, {
                                href: "/",
                                children: /*#__PURE__*/ _jsx(SimpleImage, {
                                    src: "/TPC-logo.webp",
                                    width: 181,
                                    height: 52,
                                    alt: "The Parks Channel logo"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_130px] lg:gap-x-10",
                            children: [
                                /*#__PURE__*/ _jsxs(FooterSectionWrapper, {
                                    className: "md:col-start-2 lg:col-auto lg:col-start-1",
                                    children: [
                                        /*#__PURE__*/ _jsx(FooterSectionHeading, {
                                            children: "Account"
                                        }),
                                        /*#__PURE__*/ _jsxs(FooterList, {
                                            children: [
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsx("button", {
                                                        onClick: ()=>signIn("cognito"),
                                                        children: "Sign In"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsx("button", {
                                                        onClick: ()=>signIn("cognito"),
                                                        children: "Create an account"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(FooterSectionWrapper, {
                                    className: "md:col-start-1 md:row-start-1 lg:col-start-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(FooterSectionHeading, {
                                            children: "Support"
                                        }),
                                        /*#__PURE__*/ _jsx(FooterList, {
                                            children: /*#__PURE__*/ _jsx(FooterListEl, {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "mailto:info@theparkschannel.com",
                                                    children: "info@theparkschannel.com"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(FooterSectionWrapper, {
                                    children: [
                                        /*#__PURE__*/ _jsx(FooterSectionHeading, {
                                            children: "The Parks Channel"
                                        }),
                                        /*#__PURE__*/ _jsxs(FooterList, {
                                            children: [
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        href: "/about-us",
                                                        onClick: ()=>onButtonClick("footerAboutUs"),
                                                        children: "About Us"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        href: "/for-creators",
                                                        onClick: ()=>onButtonClick("footerForCreators"),
                                                        children: "For Creators"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        href: "/utilities/policy",
                                                        onClick: ()=>onButtonClick("footerUtilitiesPolicy"),
                                                        children: "Privacy Policy"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        href: "/utilities/terms",
                                                        onClick: ()=>onButtonClick("footerTerms"),
                                                        children: "Terms & Conditions"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(FooterSectionWrapper, {
                                    children: [
                                        /*#__PURE__*/ _jsx(FooterSectionHeading, {
                                            children: "Social"
                                        }),
                                        /*#__PURE__*/ _jsxs(FooterList, {
                                            children: [
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsxs(SocialLink, {
                                                        href: "https://www.facebook.com/theparkschannel",
                                                        onClick: ()=>onButtonClick("footerFacebook"),
                                                        children: [
                                                            /*#__PURE__*/ _jsx(FacebookOutlineIcon, {
                                                                className: "w-6 h-6 text-neutral-900"
                                                            }),
                                                            "Facebook"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsxs(SocialLink, {
                                                        href: "https://www.instagram.com/theparkschannel",
                                                        onClick: ()=>onButtonClick("footerInstagram"),
                                                        children: [
                                                            /*#__PURE__*/ _jsx(InstagramOutlineIcon, {
                                                                className: "w-6 h-6 text-neutral-900"
                                                            }),
                                                            "Instagram"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsxs(SocialLink, {
                                                        href: "https://www.tiktok.com/@theparkschannel",
                                                        onClick: ()=>onButtonClick("footerTiktok"),
                                                        children: [
                                                            /*#__PURE__*/ _jsx(TiktokOutlineIcon, {
                                                                className: "w-6 h-6 text-neutral-900"
                                                            }),
                                                            "TikTok"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(FooterListEl, {
                                                    children: /*#__PURE__*/ _jsxs(SocialLink, {
                                                        href: "https://twitter.com/TheParksChannel",
                                                        onClick: ()=>onButtonClick("footerTwitter"),
                                                        children: [
                                                            /*#__PURE__*/ _jsx(TwitterOutlineIcon, {
                                                                className: "text-neutral-900"
                                                            }),
                                                            "Twitter"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mt-12",
                    children: [
                        /*#__PURE__*/ _jsx(Divider, {
                            className: "bg-neutral-200 my-4"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "bodyLarge",
                            className: "text-neutral-500 !text-xs",
                            children: "\xa9 Parks Channel 2022"
                        })
                    ]
                })
            ]
        })
    });
};
const SocialLink = (param)=>{
    let { children , onClick , href  } = param;
    return /*#__PURE__*/ _jsx("a", {
        href: href,
        className: "flex items-center gap-1 ",
        target: "_blank",
        onClick: onClick,
        children: children
    });
};
